import axios from "axios";
import axiosRetry from 'axios-retry';
import { TIMEOUT } from "@/network/variable";

const instance = axios.create({
    baseURL:process.env.VUE_APP_BASE_NET + process.env.VUE_APP_BASE_API,
    timeout: TIMEOUT,
})
instance.defaults.baseURL = process.env.VUE_APP_BASE_NET + process.env.VUE_APP_BASE_API;
instance.defaults.timeout = TIMEOUT;

axiosRetry(instance, {//传入axios实例
    retries: 3,              // 设置自动发送请求次数
    retryDelay: (retryCount) => {
        //return retryCount * 5000;      // 重复请求延迟(毫秒)
        return 0;
    },
    shouldResetTimeout: true,       //  重置超时时间
    retryCondition: (error) => {
        //true为打开自动发送请求，false为关闭自动发送请求
        if (error.message.includes('timeout')
            // || error.message.includes("status code")
        ) {
            return true;
        } else {
            return false;
        }
    }
});

// 请求拦截器
instance.interceptors.request.use(
    (config) => {
        let token = "";
        token = localStorage.getItem("X-GOLD-AUTH-TOKEN") ?  localStorage.getItem("X-GOLD-AUTH-TOKEN") : '';
        if (token) {
            config.headers["X-GOLD-AUTH-TOKEN"] =  token;
        }

        return config;
    },
    (error) => {

        return Promise.reject({
            "code": -999,
            "data": {
                "msg": "Back end interface connection exception."
            },
            "flag": false,
            "desc": "error"
        });
    }
);

instance.interceptors.response.use(
    (response) => {
        if (response.status == 200) {
            let data = response.data;
            if(data.code > -1){
                return Promise.resolve(response);
            }else{
                return Promise.reject(data);
            }
        }else {
            return Promise.reject({
                "code": -999,
                "data": {
                "msg": "not connected."
            },
                "flag": false,
                "desc": "error"
            });
        }
    },
    (error) => {
        let info = null;
        if (error.toString().indexOf("timeout")) {
            info = {
                "code": -999,
                "data": {
                    "msg": "Response timeout, please re-enter."//"Response timeout, please re-enter."
                },
                "flag": false,
                "desc": "error"
            }
        }else{
            info = {
                "code": -999,
                "data": {
                    "msg": "Back end interface connection exception."//"Back end interface connection exception."
                },
                "flag": false,
                "desc": "error"
            }
        }
        return Promise.reject(info);
    }
);

export default instance;
